import isAutoSuggestPopulated from "./isAutoSuggestPopulated";
import dispatchInitialData from "./dispatchInitialData";
import dispatchAutoSuggest from "./dispatchAutoSuggest";

const fetchData = (component, isMounting = false) => {
  if(!component.props.isStep){
    dispatchInitialData(component);
  }

  if (isAutoSuggestPopulated(component)) {
    dispatchAutoSuggest(component);
  }
};

export default fetchData;
